export const TabsHeader = (props) => {
  const { tabsGallery, setTabsGallery, tabsContent } = props;

  return (
    <div className="tabs__panel-header">
      <ul>
        {tabsContent.map((item, idx) => {
          return (
            <li onClick={() => setTabsGallery(idx)} className={`${tabsGallery === idx ? 'isActive' : ''}`} key={item.id}>
              {/* <span className="icon">{tabsGallery === idx ? <img alt="" src={`/assets/icons/${item.name.toLowerCase()}-blue.svg`} /> : <img alt="" src={`/assets/icons/${item.name.toLowerCase()}.svg`} />}</span> */}
              <span className="text">{item.name}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
